import $ from 'jquery'
import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziIFrame from 'drawer/tabs/info/fragment/iframe'
import PoziJotFormComments from 'drawer/tabs/info/fragment/jotformcomments'
import PoziJotFormLikes from 'drawer/tabs/info/fragment/jotformlikes'

import { resetFragments, setFragment } from './actions'

function PoziFragments () {
  // Adapters
  const adapters = {
    /**
     * @api {NA} PoziFragments().init Initialise fragments
     * @apiDescription Controller to add events that trigger load and unload for the fragments. Fragments are embeddable components.
     * @apiGroup Fragments
     * @apiName init
     * @apiHeader (Config) {JSON} Config TBC
     */
    init: function () {
      return init()
    },
    /**
     * @api {NA} PoziFragments().load Load fragments
     * @apiDescription Load the layer fragments into the info tab in order.
     * @apiGroup Fragments
     * @apiName load
     *
     * @apiParam {String} loadOptions.titleid Layer title ID.
     * @apiParam {String} [loadOptions.featureid] Layer feature ID.
     * @apiParam {String} [loadOptions.lng] Layer feature ID.
     * @apiParam {String} [loadOptions.lat] Layer feature ID.
     *
     * @apiSuccess {Promise} Resolve No errors
     * @apiError {Promise} Reject Error to console
     */
    load: function (loadOptions) {
      return load(loadOptions)
    },
    /**
     * @api {NA} PoziFragments().getWrapper Get wrapper
     * @apiDescription Returns the jQuery wrapper object for the fragment. This is pre-rendered to preserve object order.
     * @apiGroup Fragments
     * @apiName getWrapper
     *
     * @apiParam {Object} fragment.id Fragment ID.
     */
    getWrapper: function (fragment) {
      return getWrapper(fragment)
    }
  }

  const init = function () {
    Model.on('app.event.drawer.tabs.info.card.open', function (options) {
      load(options)
    })

    Model.on('app.event.drawer.closed', function () {
      unload()
    })
  }

  const load = function (loadOptions) {
    window.store.dispatch(resetFragments())

    return checkOptions(loadOptions)
      .then(checkFragments)
      .then(setupFragments)
      .then(success)
      .catch(error)
  }

  const getWrapper = function (fragment) {
    return $('#fragment-' + fragment.id)
  }

  const unload = function () {
    console.debug('Removing all .info-fragment elements.')

    $('.info-fragment').remove()
  }

  const checkFragments = function (loadOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''
      for (const fKey in loadOptions.fragments) {
        const fragment = loadOptions.fragments[fKey]
        if (!has(fragment, 'type')) {
          err = 'A fragment is missing type.'
          return reject(err)
        }
        if (!has(fragment, 'title')) {
          err = 'A fragment is missing title.'
          return reject(err)
        }
      }
      return resolve(loadOptions)
    })
  }

  const setupFragments = function (loadOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''
      const promises = []
      for (const fragmentKey in loadOptions.fragments) {
        const fragment = { ...loadOptions.fragments[fragmentKey] }
        fragment.id = PoziUtils.getPoziIDFromString(fragment.title)
        if (isNil(fragment.id)) {
          err = 'Unable to set fragment.id.'
          return reject(err)
        }

        const fragmentOptions = {
          loadOptions,
          fragment
        }

        // Fragment HTML wrappers are added syncronously, and then async loaders are responsible for populating.
        console.debug('Add placeholder fragments')

        $('#fragment-' + fragment.id).remove() // Remove any old fragment.
        $('#mode-' + loadOptions.titleid + ' .snippetData')
          .append($('<div>').attr('id', 'fragment-' + fragment.id))
          .addClass('info-fragment')

        const promise = loadFragment(fragmentOptions).then(function (data) {
          const titleid = get(data, 'loadOptions.layer.titleid', '')
          const fragmentid = get(data, 'fragment.id', null)
          const fragment = get(data, 'fragment', {})
          const comments = get(data, 'comments', [])

          const fragmentToBeSet = {
            fragment,
            titleid,
            fragmentid,
            comments
          }

          window.store.dispatch(setFragment(fragmentToBeSet))

          // console.debug('Fragment load data.', fragmentToBeSet)
        })

        if (!isNil(promise)) {
          promises.push(promise)
        }
      }

      Promise.all(promises)
        .then(resolve)
        .catch(reject)
    })
  }

  const loadFragment = function (fragmentOptions) {
    const type = get(fragmentOptions.fragment, 'type', null)
    if (isNil(type)) {
      console.log('Invalid fragment... no type.', fragmentOptions)
      return null
    }

    // console.debug('fragments - loadFragment', type, { ...fragmentOptions })

    const typeLowerCase = type.toLowerCase().trim()
    switch (typeLowerCase) {
      case 'iframe':
        return PoziIFrame().load(fragmentOptions) // returns promise
      case 'jotformlikes':
        return PoziJotFormLikes().load(fragmentOptions) // returns promise
      case 'jotformcomments':
        return PoziJotFormComments().load(fragmentOptions) // returns promise
      default:
        console.log('Fragment type not supported.')
        return null
    }
  }

  const checkOptions = function (loadOptions) {
    return new Promise(function (resolve, reject) {
      let err = ''

      if (isNil(loadOptions)) {
        err = 'Invalid options object.'
        return reject(err)
      }

      if (!has(loadOptions, 'titleid')) {
        err = 'No fragments found.'
        return reject(err)
      }

      loadOptions.layer = PoziUtils.getLayerFromTitleID(loadOptions.titleid)
      if (isNil(loadOptions.layer)) {
        err = 'Unable to find layer.'
        return reject(err)
      }

      loadOptions.fragments = get(loadOptions.layer, 'drawer.tabs.info.fragments', null)
      if (isNil(loadOptions.fragments)) {
        err = 'No fragments on this layer.'
        return reject(err)
      }

      return resolve(loadOptions)
    })
  }

  const success = function () {
    console.debug('Fragments all loaded.')
  }

  const error = function (err) {
    console.log('Fragments loading error:', err)
  }

  // Return adapters (must be at end of adapter)
  return adapters
}

export default PoziFragments
// End A (Adapter)
